import React, { useState, useEffect } from "react";
import { Button, Card, Form, Input, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import auth from "../../firebaseConfig";
import { useAuth } from "../context/AuthContext";
import { API_URL } from "../../config";
import { useTranslation } from "react-i18next";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { setUser, setLoginDoctorDetails } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const authToken = sessionStorage.getItem("authToken");
    if (authToken) {
      navigate("/appointments");
    }
  }, [navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    setError(null);
    try {
      await signInWithEmailAndPassword(auth, values.email, values.password);

      const currentUser = auth.currentUser;

      if (currentUser) {
        const token = await currentUser.getIdToken();
        sessionStorage.setItem("authToken", token);

        const response = await fetch(`${API_URL}/auth/portal`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          sessionStorage.clear();
          throw new Error("Failed to fetch user data.");
        }

        const loginDoctorDetails = await response.json();
        sessionStorage.setItem("ID", loginDoctorDetails.doctor_id);
        sessionStorage.setItem("username", loginDoctorDetails?.first_name)

        setLoginDoctorDetails(loginDoctorDetails);
        if (loginDoctorDetails.type === "admin") {
          navigate("/patients");
        } else if (loginDoctorDetails.type === "medicine_admin") {
          navigate("/prescription");
        } else {
          navigate("/appointments");
        }
      } else {
        setError("Failed to retrieve current user.");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card title={`${t("common.welcome")} 👋`} bordered={false} style={{ width: 300 }}>
        <Form name="login" onFinish={onFinish}>
          <Form.Item
            name="email"
            rules={[{ required: true, message: t("validation.emailAddressRequired") }]}
          >
            <Input
              placeholder={t("tableHeader.email")}
              style={{
                textTransform: "lowercase",
              }}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: t("validation.passwordRequired") }]}
          >
            <Input.Password placeholder={t("doctor.password")} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              {t("common.login")}
            </Button>
          </Form.Item>
        </Form>
        {error && <Typography.Text type="danger">{error}</Typography.Text>}
        <Button type="link" onClick={() => navigate("/reset-password")}>
          {t("common.forgotPassword")}
        </Button>
        {/* <Button type="link" onClick={() => navigate("/signup")}>
          Don't have an account? Sign Up
        </Button> */}
      </Card>
    </div>
  );
};

export default Login;
